<a mat-list-item [ngStyle]="{'padding-left': (depth * 12) + 'px'}" (click)="onItemSelected(item)"
   [ngClass]="{'expanded': expanded}" [activated]="isActive(item)">
  <mat-icon class="routeIcon" *ngIf="item.permissionIconCode">
    {{ item.permissionIconCode }}
  </mat-icon>
  <span class="disable-text-selection">{{ item.permissionName }}</span>
  <span fxFlex *ngIf="item.children && item.children.length">
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
      expand_more
    </mat-icon>
  </span>
</a>
<div *ngIf="expanded">
  <app-sidenav-list *ngFor="let child of item.children" [item]="child" [depth]="depth + 1">
  </app-sidenav-list>
</div>
